'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'hasSpecialCharacter';
const HAS_LOWERCASE_ERROR = 'hasSpecialCharacter';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? HAS_LOWERCASE_ERROR
        },
        test: (value)=>{
            if (!value) return false;
            // [https://support.okta.com/help/s/article/What-special-characters-are-accepted-by-the-Okta-password]
            // Accepts " ! # $ % & ' ( ) * + , - . / \ : ; < = > ? @ [ ] ^ _ ` { | } ~
            return /^.*[!#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~]/.test(value);
        }
    });
});

exports.HAS_LOWERCASE_ERROR = HAS_LOWERCASE_ERROR;
//# sourceMappingURL=hasSpecialCharacter.js.map
